import { render, staticRenderFns } from "./PartnerDelete.vue?vue&type=template&id=2ae7fe1c&scoped=true"
import script from "./PartnerDelete.vue?vue&type=script&lang=js"
export * from "./PartnerDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae7fe1c",
  null
  
)

export default component.exports